import ApiClient from 'apiClients/index';

const ChiliPiperClient = new ApiClient(
  `https://api.chilipiper.com/marketing/${process.env.NEXT_PUBLIC_CHILI_PIPER_DOMAIN}`
);

export default ChiliPiperClient;
